import { cn } from "@/lib/utils";
import { tr } from "@/lib/reportI18n";

export function ArchetypeGrid({ dims, scores, infoMap, testId, topLabel = "Top", lang = "en" }) {
  const sorted = [...dims].sort((a, b) => (scores?.[b] ?? 0) - (scores?.[a] ?? 0));
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid={testId}>
      {sorted.map((d, i) => {
        const info = infoMap[d];
        if (!info) return null;
        const Icon = info.icon;
        const value = Math.round(scores?.[d] ?? 0);
        return (
          <div
            key={d}
            data-testid={`${testId}-card-${d}`}
            className={cn("relative rounded-xl border p-3 flex flex-col gap-2 print:break-inside-avoid", info.bg, info.border)}
          >
            {i === 0 && (
              <span className="absolute -top-2 -right-2 text-[9px] font-bold uppercase tracking-wide bg-slate-900 text-white rounded-full px-2 py-0.5">
                {tr(topLabel, lang)}
              </span>
            )}
            <div className="flex items-center gap-2">
              <span className="h-8 w-8 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: info.color }}>
                <Icon className="h-4 w-4 text-white" />
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-slate-900 truncate">{tr(info.label, lang)}</p>
                <p className="text-[11px] text-slate-500 truncate">{tr(info.tagline, lang)}</p>
              </div>
            </div>
            <div className="h-1.5 w-full rounded-full bg-white/70 overflow-hidden">
              <div className="h-full rounded-full transition-all duration-700" style={{ width: `${value}%`, backgroundColor: info.color }} />
            </div>
            <span className={cn("self-end text-xs font-bold font-mono rounded-full px-2 py-0.5", info.chip)}>{value}</span>
          </div>
        );
      })}
    </div>
  );
}
